





















import { windowHelper } from '@tencent/ppd-base-libs';
import TextCom from '@/components/v3/text/index.vue';
import { MiniBanner } from '@/types/home-newest';
import { defineComponent, PropType, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'MiniAd',
  components: {
    TextCom,
  },
  props: {
    item: {
      type: Object as PropType<MiniBanner>,
      required: true,
    },
  },
  setup(props) {
    const biExt = computed(() => props.item.reportInfo);
    return {
      biExt,
      /** 跳转活动页面 */
      goAct() {
        if (!props.item.url) {
          return;
        }
        windowHelper.redirect(props.item.url, 300);
      },
    };
  },
});
